// extracted by mini-css-extract-plugin
export default {"root":"Je4Y1Wm8r7iE_n9cKogZ","space":"IyDPFmuX2xnMpudaDu6d","clearIcon":"uxtHr_4q1yavaWYPfiCK","total":"BZI3els7zk2UaXnxRN87","placeHolderShimmer":"XzH1NEZNnKKfYelvQITQ"};